import { createSlice } from '@reduxjs/toolkit';
import { Auth } from 'aws-amplify';
import jwt_decode from 'jwt-decode';
import {
  initialize,
  getInfo,
  putFile,
  deleteFile,
  getFileAsObject,
  listFiles,
} from '@plat/domain-api';
import logger from '../../utils/logger';
import columbiaModeEnum from '../../enums/columbiaModeEnum';
import { getColumbiaResultsFile } from './imagesSlice';
import { update_auto_linked_files } from '../services/work-item/handle-columbia';

const columbiaSlice = createSlice({
  name: 'columbia',
  initialState: {
    mode: columbiaModeEnum.INTERACTIVE,
    authToken: null,
    name: null,
    email: null,
    signIn: null,
  },
  reducers: {
    setColumbiaInfo: (state, { payload }) => {
      state.mode = payload.mode;
      state.authToken = payload.authToken;
      state.name = payload.name;
      state.email = payload.email;
    },
    setSignIn: (state, { payload }) => {
      state.signIn = payload;
    },
  },
});

export const { setColumbiaInfo, setSignIn } = columbiaSlice.actions;

export default columbiaSlice.reducer;

export const initializeColumbia = () => async (dispatch) => {
  if (window?.location === window?.parent?.location) {
    const {
      attributes: { name, email },
      signInUserSession,
    } = await Auth.currentAuthenticatedUser();
    const token = await signInUserSession?.getIdToken().getJwtToken();

    dispatch(
      setColumbiaInfo({
        authToken: token,
        mode: columbiaModeEnum.INTERACTIVE,
        name: name,
        email: email,
      }),
    );
  } else {
    await initialize();
    const { mode, authToken } = getInfo();
    const { name, email } = await jwt_decode(authToken);

    dispatch(
      setColumbiaInfo({
        authToken: authToken,
        mode: mode,
        name: name,
        email: email,
      }),
    );
    does_s3_folder_exist().then((files) => {
      if (files) {
        update_auto_linked_files().then(() => {
          dispatch(getColumbiaResultsFile());
        });
      } else {
        sendJSONListToDomainAPI([]);
      }
    });
  }

  dispatch(setSignIn(true));
};

function does_s3_folder_exist() {
  return listFiles().then((results) => {
    return results && results.length > 0;
  });
}

export function sendZipToDomainAPI(id, blob) {
  if (id) {
    try {
      return putFile(blob, `baseline_image_data_${id}.zip`, 'application/zip').then(
        (result) => result,
      );
    } catch (err) {
      logger.error({
        message: 'sendZipToDomainAPI error',
        error: err,
        function: sendZipToDomainAPI.name,
      });
    }
  }
}

export function sendJSONListToDomainAPI(list) {
  const baseline_image_index = {
    version: '1',
    images_index: list,
  };

  try {
    return putFile(
      JSON.stringify(baseline_image_index),
      'baseline_images_index.json',
      'application/json',
    ).then((result) => result);
  } catch (err) {
    logger.error({
      message: 'sendJSONListToDomainAPI error',
      error: err,
      function: sendJSONListToDomainAPI.name,
    });
  }
}

export function deleteFromDomainAPI(id) {
  try {
    if (id) {
      return deleteFile(`baseline_image_data_${id}.zip`);
    }
  } catch (err) {
    logger.error({
      message: 'deleteFromDomainAPI error',
      error: err,
      function: deleteFromDomainAPI.name,
    });
  }
}

export async function getImagesIndexFromDomainAPI() {
  /**
   * These results come from Columbia's S3 bucket:
   * plat-qa-work-item-results
   */

  try {
    return getFileAsObject('baseline_images_index.json').then((results) => results.images_index);
  } catch (err) {
    logger.error({
      message: 'getImagesIndexFromDomainAPI error',
      error: err,
      function: getImagesIndexFromDomainAPI.name,
    });
  }
}

export function getListFilesFromDomainAPI() {
  try {
    return listFiles().then((result) => result);
  } catch (err) {
    logger.error({
      message: 'getListFilesFromDomainAPI error',
      error: err,
      function: getListFilesFromDomainAPI.name,
    });
  }
}
